<template>
  <div class="Firmware-version">
    <pageTitle v-bind="{ ...pT }" />
    <business-group
      ref="businessGroup"
      :tableConfig="{ ...tableConfig }"
      :formConfig="{ ...formConfig }"
    >
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-select placeholder="请选择FAQ类型" v-decorator="['type']" style="width: 200px">
            <a-select-option v-for="(value,key) in faqTypes" :value="key" :key="key">{{
               value
            }}</a-select-option>
           </a-select>
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="请输入FAQ名称"
            v-decorator="['title']"
            style="width: 250px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
      </template>
      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="type" slot-scope="record">
          {{ faqTypes[record.type] }} 
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
      </template>
    </business-group>
    <a-modal
      :visible="visible"
      :title="title"
      destroyOnClose
      @ok="submitForm('ruleForm')"
      @cancel="resetForm('ruleForm')"
      :maskClosable="false"
    >
      <a-form-model
        ref="ruleForm"
        class="Firmware-version_ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="问题" prop="title">
          <a-textarea   placeholder="请输入问题名称" v-model="ruleForm.title"  showCount :maxlength="64" />
        </a-form-model-item>
        <a-form-model-item label="回答" prop="answer">
          <a-textarea   placeholder="请输入回答名称" v-model="ruleForm.answer" showCount :maxlength="1024"  />
        </a-form-model-item>
        <a-form-model-item label="问题类型" prop="type">
          <a-select  v-model="ruleForm.type" placeholder="请选择问答类型" >
            <a-select-option v-for="(value,key) in faqTypes" :key="Number(key)" :value="Number(key)" >
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="语言" prop="lang">
          <a-select  v-model="ruleForm.lang" placeholder="请选择问答语言" >
            <a-select-option v-for="el in langs" :key="el" :value="el" >
              {{ el }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import formSkeleton from "@/components/business/Form/formSkeleton";
import { confirm, tips } from "@/utils/util";
import moment from "moment";
import { multipartUpload } from "@/utils/Oss";
import { formatToStr } from "@/utils/dateUtils";
export default {
  components: {
    pageTitle,
    businessGroup,
    formTime,
    formSkeleton
  },
  name: "Firmware-version",
  created() {
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };

    let checkInput = (rule, value, callback) => {
        const regex = /[A-Za-z0-9]+/;
        if (value === "" || value === undefined) {
          callback(new Error("不能为空"));
        }else if(!regex.test(value)){
          callback(new Error("不能只包含特殊字符"));
        } else {
          callback();
        }
      };

    return {
      faqTypes:{1:"RGB Light",2:"Bi-Color Light",3:"Ring Light",4:"Continuous Light",5:"Strobe Flash",6:"Camera Speedlite Flash",7:"Control System",8:"Lens & Filter",9:"Monitor",10:"Slider",11:"Stand & Tripod",12:"Softbox",13:"Battery & Charger",14:"USB microphone"},
      langs:["cn","de","en","fr","es","it","jp","nl"],
      upLoading: false,
      files: [],
      dateFormat: this.$root.$data.dateFormat,
      nowTitleIsNew: false, //当前弹窗类型
      fileName: "",
      title: undefined,
      pT: {
        pageTitle: "FAQ管理",
        // headerTitle: "更新时间",
        // text: "(单次操作不超过1年)"
      },
      tableConfig: {
        url: "bluetoothlight/web/v1/support-faq/getPage",
        columns: [
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            align: "center",
          },
          {
            title: "问题",
            dataIndex: "title",
            key: "title",
            align: "center",
          },
          {
            title: "回答",
            dataIndex: "answer",
            key: "answer",
            align: "center"
          },
          {
            title: "问题类型",
            key: "type",
            align: "center",
            scopedSlots: { customRender: "type" }
          },
          {
            title: "语言",
            dataIndex: "lang",
            key: "lang",
            align: "center"
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" },
          }
        ],
        rowKey: "ID",
      },
      formConfig: {
        timeShow: false,
        formShow: true,
      },
      pageLoading: false,
      loading: false,
      visible: false,
      ruleForm: {
        // packageSize 默认为禁用 文件上传成功之后回显
      },
      rules: {
        title: [
          { required: true, validator: checkInput, trigger: "change", message: "标题不能为空,且不能只输入特殊符号" },
        ],
        answer: [
          { required: true, validator: checkInput, trigger: "change", message: "回答不能为空,且不能只输入特殊符号" }
        ],
        type: [
          { required: true, validator: validatePass, trigger: "change", message: "问题类型不能为空" }
        ]
      },
      refresh: false,
      upUserList: [],
    };
  },
  methods: {
    moment,
    dataFormatStr(ret,format){
      if(!ret){
          return "";
      }
      if(!format){
          format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret,format)
    },
    add() {
      this.title = "新增";
      this.visible = true;
      this.nowTitleIsNew = true;
    },
    details: async function (id) {
      if (this.loading) return false;
      this.loading = true;
      const res = await this.$get(`bluetoothlight/web/v1/support-faq/detail/${id}`);
      this.loading = false;
      return res?.resultData || {};
    },
    // 编辑  deviceModel 转了 number
    edit: async function (record) {
      this.nowTitleIsNew = false;
      const data = await this.details(record?.id);
      // 回显更新包链接
      this.files = [
        {
          uid: data.id || "-1",
          name: data.name || "更新包",
          status: "done",
          url: data.url,
        },
      ];
      this.ruleForm = { ...data};
      this.title = "编辑";
      this.visible = true;
    },
    // 删除  关键词  rowKey
    del(record) {
      const id = record?.id;
      if (!id || this.pageLoading) return false;

      this.pageLoading = true;

      const payload = {
        okBack: async () => {
          const res = await this.$http(
            "DELETE",
            `bluetoothlight/web/v1/support-faq/delete/${id}`
          );
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `是否删除该说明书`,
      };
      confirm(this, payload);
      this.pageLoading = false;
    },
    // 验证表单和提交数据
    submitForm(formName) {
      if (!formName) return false;
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return false;

        let releaseDate = this.ruleForm?.releaseDate;
        if (releaseDate) {
          releaseDate = this.dataFormatStr(releaseDate,'YYYY-MM-DD');
        }

        let res;
        if(this.nowTitleIsNew){
          res = await this.$put(
              `bluetoothlight/web/v1/support-faq/add`,
              {
              ...this.ruleForm
              }
          );
        }else{
          res = await this.$post(
              `bluetoothlight/web/v1/support-faq/edit`,
              {
              ...this.ruleForm
              }
          );
        }
         
        const resultStatus = res?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.visible = false;
          this.refreshData();
          this.resetForm("ruleForm");
        }
      });
    },
    // 重置表单和隐藏 modal
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
      this.ruleForm = {};
      this.files = [];
      if (this.upLoading) {
        this.upLoading = false;
      }
    },
    // 刷新table数据
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },

    cancel(cancel) {
      return cancel;
    },
    UploadClient: async function (file) {
      //console.log(file);
      this.fileName ="instruction/" + (file?.name || file?.uid)?.replace(".xlsx", "");
      this.upLoading = true;
      const res = await multipartUpload(this.fileName, file, this.cancel,"neewer_support");
      //console.log(res);
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        this.upLoading = false;
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      // const res = await multipartUpload(this.fileName, file, this.cancel);
      if (!this.visible) return false; // 上传开始之后, 关闭了弹窗则阻止数据更新。应该是 取消 client的上传
      this.files = [{ ...res, uid: file?.uid }];

      // 计算md5
      const sliceLength = 10;
      const chunkSize = Math.ceil(file.size / sliceLength);
      const fileReader = new FileReader();
      let index = 0;
      const loadFile = () => {
        const slice = file.slice(index, index + chunkSize);
        fileReader.readAsBinaryString(slice);
      };
      loadFile();
      fileReader.onload = () => {
        if (index < file.size) {
          index += chunkSize;
          loadFile();
        } else {
        }
      };

      this.ruleForm.url = res?.url;

      this.upLoading = false;
    },
    /**
     *  文件上传处理 返回结果时 false, 结束upload的事件
     *  @param {File} file
     *  fileName 获取文件的 name或者id
     *  client 上传到oss 返回  {url,name}
     * */
    beforeUpload(file) {
      this.UploadClient(file);

      return false;
    },
    remove() {
      this.ruleForm.url = undefined;
      this.files = [];
    },
  },
};
</script>

<style lang="less" scoped>
.m-upload {
  .ant-upload-select {
    width: 60px;
    height: 60px;
    border: 1px solid #c3c3c3;
    text-align: center;
    line-height: 60px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}

.Firmware-version_ruleForm {
  width: 380px;
  margin: 0 auto;

  .ant-form-item-children,
  .ant-calendar-picker {
    width: 100%;
  }
}
</style>
